import React, { useState, useEffect } from "react";
import server from '../../../api/server'
import { useToast } from '../../../context/ToastContext'
import ModernTimeDropdown from "../../../dashboard-components/layouts/modernDropdown";

const CreateCampaignModal = ({onCreateCampaign, client_id, email}) => {
  const [campaignID, setCampaignID] = useState('')
  const [campaignName, setCampaignName] = useState('')
  const [agent, setAgent] = useState('')
  const [maxRetries, setMaxRetries] = useState('')
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)
  const [agentsList, setAgentsList] = useState([])
  const [phoneNumbersList, setPhoneNumbersList] = useState([])
  const { showToast } = useToast()
  const handleCreate = async () => {
    try {
        setLoading(true)
        if(!campaignName || !agent || !maxRetries || !phone){
            setLoading(false)
            showToast('Please fill all the fields', 'error')
            return
        }
        let res = await server.create_voice_agent_campaign(client_id, null, email, 'campaigns', undefined, campaignID, campaignName, agent, maxRetries, phone)
        if(res.status === 200){
            setLoading(false)
            setCampaignID('')
            setCampaignName('')
            setAgent('')
            setMaxRetries('')
            setPhone('')
            onCreateCampaign()
        }
    } catch (error) {
        console.log(error)
        setLoading(false)
    }
  }

  const getAgentsList = async () => {
    let res = await server.getAgentsList(client_id, null, email, 'campaigns', undefined)
    if(res.status === 200){
      let resp = await res.json()
      let agents = []
      let temp = []
      for(let i=0;i<resp.data.length;i++){
        agents.push(resp.data[i].agent_id)
        temp.push(resp.data[i].phonenumber)
      }
      setAgentsList(agents)
      setPhoneNumbersList(Array.from(new Set(temp)))
    }
  }
  const generateAgentId = () => {
    const randomString = Math.random().toString(36).substring(2, 10).toUpperCase();
    return `C${randomString}`;
  };

  useEffect(()=>{
    setCampaignID(generateAgentId())
    getAgentsList()
  }, [])
  return (
    <div className="pb-4 px-4">
      {!loading && <div style={{gap: "10px", display: "flex", flexDirection: "column", margin: "10px", height: "55vh"}}>
        <div>
            <div style={{fontSize: "13px"}}>Campaign ID</div>
            <input disabled value={campaignID} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
        </div>
        <div>
            <div style={{fontSize: "13px"}}>Campaign Name</div>
            <input value={campaignName} onChange={(e)=>setCampaignName(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
        </div>
        <div>
            <div style={{fontSize: "13px"}}>Select Agent</div>
            <ModernTimeDropdown options={agentsList} value={agent} placeholder="Select Agent" width="w-full"  onChange={(e)=>setAgent(e.target.value)} />
        </div>
        <div>
            <div style={{fontSize: "13px"}}>Max Retries</div>
            <input value={maxRetries} type="number" onChange={(e)=>setMaxRetries(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:border-indigo-500" style={{fontSize: "13px", padding: "0.3rem"}} />
        </div>
        <div>
            <div style={{fontSize: "13px"}}>Phone</div>
            <ModernTimeDropdown options={phoneNumbersList} value={phone} placeholder="Select Phone" width="w-full"  onChange={(e)=>setPhone(e.target.value)} />
        </div>
      </div>}
      {
        loading && (
          <div className="flex justify-center items-center" style={{ flexDirection: "column", height: "55vh" }}>
              <div className="loader"></div>
              <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
          </div>
        )
      }
      <div className="flex justify-end mx-3">
        <button className="flex items-center px-4 py-2 rounded text-sm text-white hover:opacity-90" style={{ backgroundColor: "rgb(79, 70, 229)", fontSize: "13px" }} onClick={handleCreate}>Create</button>
      </div>
    </div>
  )
}

export default CreateCampaignModal;